export default {
    WINDOWS_PHONE: 'Windows Phone',
    WINDOWS: 'Windows',
    IOS: 'iOS',
    MACOS: 'macOS',
    ANDROID: 'Android',
    LINUX: 'Linux',
    OUTRO: 'Outro'
}